var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[_vm._l((_vm.timeline),function(item,index){return [_c('Year',{key:index,attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }